// バリエーションあり商品のメタフィールド用（商品詳細から遷移ボタン）
const variantOptionElement = document.querySelector('.variant-option');
if (variantOptionElement) {
  variantOptionElement.addEventListener('change', function () {
    const selectedValue = this.value;
    const productDisplay = document.querySelector('.product-display')
    const variantDisplay = document.querySelectorAll('.variant-display');

    if (selectedValue === 'not-selected') {
      productDisplay.style.display = 'flex';
    } else {
      productDisplay.style.display = 'none';
    }

    variantDisplay.forEach(el => {
      if (el.dataset.selected === selectedValue) {
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  });
}
